module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDIwTDAgMTBMMTAgMEwxMS43NzUgMS43NzVMMy41NSAxMEwxMS43NzUgMTguMjI1TDEwIDIwVjIwIiBmaWxsPSIjMTcxQzIzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/back.svg
// module id = dqYA
// module chunks = 1